// Socio Assets (Hospital partners)
import alemana from '../assets/socios/alemana.png';
import indisa from '../assets/socios/indisa.png';
import redsalud from '../assets/socios/redsalud.png';
import santamaria from '../assets/socios/santamaria.png';
import ssmaule from '../assets/socios/ssmaule.png';
import ssmo from '../assets/socios/ssmo.png';
import uandes from '../assets/socios/uandes.png';

export const sociosData = [
    { src: alemana, alt: 'Clínica Alemana' },
    { src: indisa, alt: 'Clínica Indisa' },
    { src: redsalud, alt: 'Red Salud' },
    { src: santamaria, alt: 'Clínica Santa María' },
    { src: ssmaule, alt: 'Servicio de Salud Maule' },
    { src: ssmo, alt: 'Servicio de Salud Metropolitano Oriente' },
    { src: uandes, alt: 'Clínica Universidad de los Andes' }
];
